/* eslint-disable max-classes-per-file */
import { useMemo } from "react";
import {
    TicketState,
} from "../../__generated__/api";
import TicketItem from "./ticket-item";

export default class ColumnStateCache {
    public static useColumnStateCache(
        states: TicketState[] | undefined,
    ) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useMemo(() => {
            const ticketStatesByStatus = states?.flatMap(
                ticketState => ticketState.chatStatuses.map(status => ({ status, ticketState })),
            ).groupBy("status", "ticketState");
            const ticketStateMap = states?.toIdMap("id", state => ({
                state,
                statuses: new Set(state.chatStatuses),
            }));
            return new ColumnStateCache(ticketStatesByStatus, ticketStateMap);
        }, [states]);
    }

    // eslint-disable-next-line no-useless-constructor
    private constructor(
        private readonly byStatus: Record<string, TicketState[]> | undefined,
        private readonly statusMap: Record<string, {state: TicketState, statuses: Set<string>}> | undefined,
    ) {
        // none
    }

    public getForTicket(
        ticketItem: TicketItem,
    ) {
        if (ticketItem.isArchived) {
            return undefined;
        }
        const ticketState = ticketItem.ticketStateId
            ? this.statusMap?.[ticketItem.ticketStateId]
            : undefined;

        if (ticketState && (ticketState.statuses.size === 0 || ticketState.statuses.has(ticketItem.status))) {
            return ticketState.state;
        }
        return this.byStatus?.[ticketItem.status]?.firstElement;
    }

    public getById(id: string) {
        return this.statusMap?.[id]?.state;
    }
}
